
require(["readium_shared_js/globalsSetup"]);
